'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ShareSocials = require('./ShareSocials.scss');

var _ShareSocials2 = _interopRequireDefault(_ShareSocials);

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

var _reactSocial = require('react-social');

var _reactIntl = require('react-intl');

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ShareSocials: {
    displayName: 'ShareSocials'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/ShareSocials/ShareSocials.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var ShareSocials = _wrapComponent('ShareSocials')((_dec = (0, _reactRedux.connect)(null, { copyLink: _trip.copyLink }), _dec2 = (0, _reactCssModules2.default)(_ShareSocials2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ShareSocials, _Component);

  function ShareSocials() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShareSocials);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareSocials.__proto__ || (0, _getPrototypeOf2.default)(ShareSocials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _this.copyLink = function () {
      _this.props.copyLink();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShareSocials, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true }); // eslint-disable-line
    }
  }, {
    key: 'render',
    value: function render() {
      var facebookImage = require('theme/images/social/facebook-c.png');
      var twitterImage = require('theme/images/social/twitter-c.png');
      var pintarestImage = require('theme/images/social/pinterest-c.png');
      var googleImage = require('theme/images/social/google-c.png');
      if (this.state.mounted) {
        // bug "window" variable for server-side rendering
        return _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'div',
            { styleName: 'social-flex' },
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement(
                _reactSocial.FacebookButton,
                { appId: '512381822169849', styleName: 'social-link', url: window.location.toString() },
                _react3.default.createElement('img', { src: facebookImage, alt: 'facebook' }),
                _react3.default.createElement(
                  'span',
                  null,
                  'Facebook'
                )
              ),
              _react3.default.createElement(
                _reactSocial.TwitterButton,
                { styleName: 'social-link', url: window.location.toString() },
                _react3.default.createElement('img', { src: twitterImage, alt: 'twitter' }),
                _react3.default.createElement(
                  'span',
                  null,
                  'Twitter'
                )
              )
            ),
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement(
                _reactSocial.PinterestButton,
                { styleName: 'social-link', url: window.location.toString() },
                _react3.default.createElement('img', { src: pintarestImage, alt: 'pinterest' }),
                _react3.default.createElement(
                  'span',
                  null,
                  'Pinterest'
                )
              ),
              _react3.default.createElement(
                _reactSocial.GooglePlusButton,
                { styleName: 'social-link', url: window.location.toString() },
                _react3.default.createElement('img', { src: googleImage, alt: 'google' }),
                _react3.default.createElement(
                  'span',
                  null,
                  'Google plus'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'button-group' },
            _react3.default.createElement(
              _reactCopyToClipboard2.default,
              { text: 'https://www.takemetour.com/trip/' + this.props.slug },
              _react3.default.createElement(
                'a',
                { styleName: 'button', onClick: this.copyLink },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.copy_link.button' })
              )
            ),
            _react3.default.createElement(
              'a',
              { styleName: 'button', href: 'mailto:someone@example.com' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.send_email.button' })
            )
          )
        );
      }
      return _react3.default.createElement('div', null);
    }
  }]);
  return ShareSocials;
}(_react2.Component), _class2.propTypes = {
  slug: _react2.PropTypes.string,
  copyLink: _react2.PropTypes.func
}, _temp2)) || _class) || _class));

exports.default = ShareSocials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/ShareSocials/ShareSocials.js
// module id = 1527
// module chunks = 0